import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'features.documentaArea.title',
    defaultMessage: 'Documenti',
    description: '',
  },

  documentTab: {
    id: 'features.documentaArea.documentTab',
    defaultMessage: 'Documenti',
    description: 'item tab bar document page',
  },

  informationOfferTab: {
    id: 'features.documentaArea.informationOfferTab',
    defaultMessage: 'Informativa individuale',
    description: 'item tab bar document page',
  },

  communicationsTab: {
    id: 'features.documentaArea.communicationsTab',
    defaultMessage: 'Comunicazioni',
    description: 'item tab bar document page',
  },

  contractItem: {
    id: 'features.documentaArea.contractItem',
    defaultMessage: 'Contratti',
    description: 'item of chipsBar document page',
  },

  dispositionsItem: {
    id: 'features.documentaArea.dispositionsItem',
    defaultMessage: 'Disposizioni',
    description: 'item of chipsBar document page',
  },

  expiredDocumentsItem: {
    id: 'features.documentaArea.expiredDocumentsItem',
    defaultMessage: 'Documenti scaduti',
    description: 'item of chipsBar document page',
  },

  titleLabelTable: {
    id: 'features.documentaArea.titleLabelTable',
    defaultMessage: 'Titolo',
    description: 'title table ',
  },

  practiceNumberLabelTable: {
    id: 'features.documentaArea.practiceNumberLabelTable',
    defaultMessage: 'Numero pratica',
    description: 'practice number label',
  },

  loadingDateLabelTable: {
    id: 'features.documentaArea.loadingDateLabelTable',
    defaultMessage: 'Data caricamento',
    description: 'loading date label',
  },

  signatureDateLabelTable: {
    id: 'features.documentaArea.signatureDateLabelTable',
    defaultMessage: 'Data firma',
    description: 'signature date label',
  },

  expirationDateLabelTable: {
    id: 'features.documentaArea.expirationDateLabelTable',
    defaultMessage: 'Data scadenza',
    description: 'expiration date label',
  },

  amountLabelTable: {
    id: 'features.documentaArea.amountLabelTable',
    defaultMessage: 'Importo',
    description: 'amount label',
  },

  companyLabelTable: {
    id: 'features.documentaArea.companyLabelTable',
    defaultMessage: 'Compagnia',
    description: 'company label',
  },

  documentTypeLabelTable: {
    id: 'features.documentaArea.documentTypeLabelTable',
    defaultMessage: 'Tipo documento',
    description: 'document type label',
  },

  notRead: {
    id: 'features.documentaArea.notRead',
    defaultMessage: 'Non letti',
    description: 'text for the not read check box filter',
  },

  read: {
    id: 'features.documentaArea.read',
    defaultMessage: 'Letti',
    description: 'text for the read select filter',
  },

  notReadBadge: {
    id: 'features.documentaArea.notReadBadge',
    defaultMessage: 'Non letto',
    description: 'not Read Badge',
  },

  unavailableDocuments: {
    id: 'features.documentaArea.unavailableDocuments',
    defaultMessage: 'Non ci sono documenti disponibili',
    description: 'Label when there are no documents available',
  },

  practiceTitle: {
    id: 'features.documentaArea.practiceTitle',
    defaultMessage: 'Pratica n° {practiceNumber}',
    description: 'Accordion label for base practice',
  },

  practiceArchivedTitle: {
    id: 'features.documentaArea.practiceArchivedTitle',
    defaultMessage: 'Archiviati',
    description: 'Accordion label for archived practice',
  },

  // Report Type

  SummaryPositionReportType: {
    id: 'features.documentaArea.SummaryPositionReportType',
    defaultMessage: 'Posizione riepilogativa',
    description: 'Label for summary position report type',
  },
  WealthManagementReportType: {
    id: 'features.documentaArea.WealthManagementReportType',
    defaultMessage: 'Gestioni patrimoniali',
    description: 'Label for wealth management report type',
  },
  WealthManagementExPostReportType: {
    id: 'features.documentaArea.WealthManagementExPostReportType',
    defaultMessage: 'Gest.  patrim.  ex post',
    description: 'Label for wealth management ex post report type',
  },
  WealthManagementClosedAccountsReportType: {
    id: 'features.documentaArea.WealthManagementClosedAccountsReportType',
    defaultMessage: 'Gest. patrim. ex post conti chiusi (rendiconti light)',
    description: 'Label for wealth management closed accounts report type',
  },
  MAXReportType: {
    id: 'features.documentaArea.MAXReportType',
    defaultMessage: 'MAX',
    description: 'Label for MAX report type',
  },
  MAXFundReportType: {
    id: 'features.documentaArea.MAXFundReportType',
    defaultMessage: 'MAX Fund',
    description: 'Label for MAX fund report type',
  },
  MAXOmnibusReportType: {
    id: 'features.documentaArea.MAXOmnibusReportType',
    defaultMessage: 'MAX Omnibus',
    description: 'Label for MAX omnibus report type',
  },
  MAXExPostReportType: {
    id: 'features.documentaArea.MAXExPostReportType',
    defaultMessage: 'MAX ex post',
    description: 'Label for MAX ex post report type',
  },
  RTOReportType: {
    id: 'features.documentaArea.RTOReportType',
    defaultMessage: 'RTO',
    description: 'Label for RTO report type',
  },
  RTOOmnibusReportType: {
    id: 'features.documentaArea.RTOOmnibusReportType',
    defaultMessage: 'RTO omnibus',
    description: 'Label for RTO omnibus report type',
  },
  RTOClosedReportType: {
    id: 'features.documentaArea.RTOClosedReportType',
    defaultMessage: 'RTO chiusi',
    description: 'Label for RTO closed report type',
  },
  RTOExPostReportType: {
    id: 'features.documentaArea.RTOExPostReportType',
    defaultMessage: 'RTO con ex post',
    description: 'Label for RTO ex post report type',
  },
  RTOExPostClosedAccountsReportType: {
    id: 'features.documentaArea.RTOExPostClosedAccountsReportType',
    defaultMessage: 'RTO ex post conti chiusi (rendiconto light)',
    description: 'Label for RTO ex post closed accounts report type',
  },
  IDDReportExPostReportType: {
    id: 'features.documentaArea.IDDReportExPostReportType',
    defaultMessage: 'Rendiconto IDD ex post',
    description: 'Label for IDD ex post report type',
  },
  ExpensesReportExPostBaseConsultingReportType: {
    id: 'features.documentaArea.ExpensesReportExPostBaseConsultingReportType',
    defaultMessage: 'Rendiconto costi ex post consulenza base',
    description: 'Label for expenses ex post base consulting report type',
  },
  PIRReportType: {
    id: 'features.documentaArea.PIRReportType',
    defaultMessage: 'Rendiconto PIR',
    description: 'Label for PIR report type',
  },

  // label card documents

  noDocumentsLabelPartOne: {
    id: 'features.documentaArea.noDocumentsLabelPartOne',
    defaultMessage: 'Non hai',
    description: '',
  },

  noDocumentsLabelPartTwo: {
    id: 'features.documentaArea.noDocumentsLabelPartTwo',
    defaultMessage: 'ancora Documenti',
    description: '',
  },

  //azimut life label

  azimutLifeLabel: {
    id: 'features.documentaArea.azimutLifeLabel',
    defaultMessage: 'Azimut life',
    description: '',
  },

  azimutLifeBodyError: {
    id: 'features.documentaArea.azimutLifeBodyError',
    defaultMessage:
      'Non è stato possibile accedere alla sezione contenente la documentazione delle polizze AzLife',
    description: '',
  },
});
